module.exports = __webpack_public_path__ + "img/empty.acaab9d4.gif";